import { FieldworkV2Query } from '../data/gql-gen/questionnaire/graphql'

type Fieldwork = Pick<
  NonNullable<FieldworkV2Query['fieldwork']>,
  'languageAllocations' | 'locale'
>

/**
 * The languages a market fields, as its fieldwork declares them: its language
 * allocations, falling back to its locale's language. Codes are as stored and
 * may carry a region ("de-DE").
 */
export const fieldworkLanguages = (
  fieldwork: Fieldwork | null | undefined
): string[] => {
  const allocated = (fieldwork?.languageAllocations ?? []).map(
    (allocation) => allocation.language
  )
  if (allocated.length > 0) {
    return allocated
  }
  const localeLanguage = fieldwork?.locale.language
  return localeLanguage ? [localeLanguage] : []
}
